import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { env } from '@fiverr-private/futile/lib/env';
import { Button } from '@fiverr-private/fit';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import SharingLink from '@fiverr-private/sharing_link/src/SharingLink';

const SocialSharing = ({ title, customClass, gigId, gigTitle, isPageOwner, sellerName }) => {

    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    const onSharingClick = () => {

        let openShareEvent;

        if (env.browser) {

            const data = {
                detail: {
                    source: isPageOwner ? 'gigs_show' : 'gigs_show_buyers',
                    resource_type: 'gig',
                    resource_id: gigId,
                    is_resource_owner: isPageOwner,
                    interpolation_variables: {
                        username: sellerName,
                        gig_title: gigTitle
                    }
                }
            };

            if (typeof window.CustomEvent === 'function') {
                openShareEvent = new CustomEvent('open-share-modal', data);
            } else {
                openShareEvent = document.createEvent('CustomEvent');
                openShareEvent.initCustomEvent('open-share-modal', false, false, data.detail);
            }

            window.dispatchEvent(openShareEvent);
        }
    };


    return (
        <>
            <Button className={classNames('btn-sharing-link', customClass)} onClick={onSharingClick} size="small">
                {title}
            </Button>
            <SharingLink locale={locale}/>
        </>
    );
};

SocialSharing.propTypes = {
    gigId: PropTypes.number,
    gigTitle: PropTypes.string,
    isPageOwner: PropTypes.bool,
    sellerName: PropTypes.string,
    title: PropTypes.node,
    customClass: PropTypes.string
};

export default SocialSharing;
